import { SignIn } from '@clerk/clerk-react';

export function Login() {
  return (
    <main className="access-screen">
      <SignIn />
    </main>
  );
}
